import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import { dateFormatter } from 'src/utils/formatters';
import { OperacionLCTCCuentaHistoriaDTO } from '../types/dto';
import { OperacionLCTCCuentaFields, OperacionLCTCCuentaLimiteFields } from '../types/fields';

interface OperacionLCTCLimitesDialogHistorialProps {
    open: boolean;
    onClose: () => void;
    historia: OperacionLCTCCuentaHistoriaDTO[];
}

export const OperacionLCTCLimitesDialogHistorial = ({ open, onClose, historia }: OperacionLCTCLimitesDialogHistorialProps) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
            <DialogTitle>Historial de Límites</DialogTitle>
            <DialogContent>
                <TableContainer component={Paper}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell><Typography variant="body2">Participante</Typography></TableCell>
                                <TableCell><Typography variant="body2">Tipo Cliente</Typography></TableCell>
                                <TableCell><Typography variant="body2">Sub-tipo</Typography></TableCell>

                                <TableCell align="right"><Typography variant="body2">Límite Concertación</Typography></TableCell>
                                <TableCell><Typography variant="body2">Fecha Acción</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody> 
                            {historia.map((limite) => (
                                <TableRow key={limite.id}>
                                    <TableCell>{limite[OperacionLCTCCuentaLimiteFields.DescGrupo]}</TableCell>
                                    <TableCell>{limite[OperacionLCTCCuentaLimiteFields.ClienteTipo]}</TableCell>
                                    <TableCell>{limite[OperacionLCTCCuentaLimiteFields.ClienteSubTipo] || '-'}</TableCell>
                                    <TableCell align="right">{limite[OperacionLCTCCuentaLimiteFields.LimiteConcertacion]}</TableCell>
                                    <TableCell>{dateFormatter.toShortDate(limite[OperacionLCTCCuentaLimiteFields.FechaAccion])}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
};
